(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.qjDesktop = window.matchMedia('(min-width: 1025px)');
      this.qjRowWrappers = Array.from(document.querySelectorAll('.shopify-section-group-header-group')).filter(
        (wrapper) => wrapper.querySelector(':scope > section.mega--menu')
      );
      this.qjRowWrappers.forEach((wrapper) => wrapper.classList.add('qj-nav-row'));

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    qjSetOffsets() {
      /* 1px overlap between stacked bars prevents sub-pixel see-through seams. */
      const barHeight = this.header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--qj-bar-h', `${barHeight}px`);
      let top = barHeight - 1;
      this.qjRowWrappers.forEach((wrapper) => {
        wrapper.style.setProperty('--qj-row-top', `${top}px`);
        top += wrapper.getBoundingClientRect().height - 1;
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.qjDesktop.matches) {
        /* Animate the tuck-away only when already in the scrolled state;
           on first entry the rows must vanish instantly or they flash
           while transitioning from their pinned position. */
        const wasScrolled = document.body.classList.contains('qj-scrolled');
        document.body.classList.toggle('qj-anim', wasScrolled);
        this.header.classList.add('qj-slim');
        document.body.classList.add('qj-scrolled');
        document.body.classList.remove('qj-nav-open');
        requestAnimationFrame(() => this.qjSetOffsets());
      } else {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.qjDesktop.matches) {
        this.header.classList.add('qj-slim');
        document.body.classList.add('qj-scrolled');
        this.qjSetOffsets();
        document.body.classList.add('qj-anim', 'qj-nav-open');
      } else {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('qj-slim');
      document.body.classList.remove('qj-scrolled', 'qj-nav-open', 'qj-anim');
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
